import { useEffect, useRef, useState } from "react";
import { useCityInfo } from "../../hooks/useAudios/useCityInfo";

const PIXELS_PER_SECOND = 30;

const CityInfoItem = ({ city }) => (
  <span className="flex items-center gap-1.5 text-white/85 text-xs sm:text-[13px] font-medium shrink-0">
    <span className="w-1.5 h-1.5 rounded-full bg-white/60 shrink-0" />
    {city.name} · {city.time}
    {city.temperature != null && (
      <>
        {" "}
        · {city.temperature}°
        <span title={city.label} className="text-base leading-none">
          {city.emoji}
        </span>
      </>
    )}
  </span>
);

export const CityInfoTicker = () => {
  const cities = useCityInfo();
  const trackRef = useRef(null);
  const [trackWidth, setTrackWidth] = useState(0);

  useEffect(() => {
    if (!trackRef.current || cities.length === 0) return;

    const observer = new ResizeObserver(([entry]) => {
      const width = entry.target.getBoundingClientRect().width;
      setTrackWidth((prev) => (Math.abs(prev - width) > 0.5 ? width : prev));
    });
    observer.observe(trackRef.current);

    return () => observer.disconnect();
  }, [cities]);

  if (cities.length === 0) return null;

  const duration = trackWidth > 0 ? trackWidth / PIXELS_PER_SECOND : 0;

  return (
    <div className="w-full overflow-hidden">
      <style>{`
        @keyframes city-info-ticker-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-${trackWidth}px); }
        }
      `}</style>
      <div
        className="flex items-center whitespace-nowrap"
        style={{
          width: "max-content",
          animation: trackWidth > 0 ? `city-info-ticker-scroll ${duration}s linear infinite` : "none",
        }}
      >
        <div ref={trackRef} className="flex items-center gap-6 pr-6 shrink-0">
          {cities.map((city) => (
            <CityInfoItem key={city.name} city={city} />
          ))}
        </div>
        <div className="flex items-center gap-6 pr-6 shrink-0" aria-hidden="true">
          {cities.map((city) => (
            <CityInfoItem key={`dup-${city.name}`} city={city} />
          ))}
        </div>
      </div>
    </div>
  );
};
